import React from 'react';

import { LayoutPageHeading } from 'src/modules/layout';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { useLocale } from 'src/modules/locale';
import ProfessionalsDownloadsProductsSearchIndex from '../../search/index/ProfessionalsDownloadsProductsSearchIndex';

import styles from './ProfessionalsDownloadsProductsPageIndex.module.scss';
import ProductList from '../../product-list/ProductList';
import useRedrawOnMountKey from 'src/utils/useRedrawOnMountKey';

const ProfessionalsDownloadsProductsPageIndex = (props) => {
  const { intl } = useLocale();

  // workaround to fix language issue on SSG
  const redrawKeySearchIndex = useRedrawOnMountKey();

  const filterData = props.productsDownloadsPage.filterData;

  const pageProperties = {
    title: intl.formatMessage({
      id: 'page/professionals/downloads/products/index/head/page_title',
    }),
    description: intl.formatMessage({
      id: 'page/professionals/downloads/products/index/head/meta_description',
    }),
  };

  return (
    <LayoutPage
      {...pageProperties}
      breadcrumbs={[
        {
          title: intl.formatMessage({ id: 'breadcrumbs/professionals' }),
          href: '/professionals',
        },
        {
          title: intl.formatMessage({ id: 'breadcrumbs/professionals/downloads' }),
          href: '/professionals/downloads',
        },
        {
          title: intl.formatMessage({ id: 'breadcrumbs/professionals/downloads/product_data' }),
          href: '/professionals/downloads/products',
        },
      ]}>
      <LayoutPageHeading titleKey={'page/professionals/downloads/products/index/title'} />
      <section className={styles.productsContainer}>
        <ProfessionalsDownloadsProductsSearchIndex key={redrawKeySearchIndex} {...filterData} />
        <ProductList />
      </section>
    </LayoutPage>
  );
};

export default ProfessionalsDownloadsProductsPageIndex;
